import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-fiche-client',
  templateUrl: './fiche-client.component.html',
  styleUrls: ['./fiche-client.component.scss'],
})
export class FicheClientComponent implements OnInit {
  constructor(public generalService: GeneralService) {}
  client;
  clientData;
  ngOnInit(): void {}
  afficher() {
    this.generalService
      .getDS('avtclient', this.client)
      .subscribe((res: any) => {
        this.clientData = res.Tiers[0];
      });
  }
}
